module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-regular.woff
// module id = VUwF
// module chunks = 0